import { SummaryStatsCard } from '@exam-center/components';
import { useAdminGetExamRoomRequestInfoCountQuery } from '@exam-center/graphql';
import { Flex } from '@shared/components';

export default function ExamLocationRequestSupervisorStatusSummary() {
  const { data, loading: isLoading } = useAdminGetExamRoomRequestInfoCountQuery();

  const stats = data?.ecAdminGetExamRoomRequestInfoCount?.examRoomRequestInfoCountByStatus;
  const numberOfInReview = stats?.inReview ?? 0;
  const numberOfRejected = stats?.rejected ?? 0;

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
      <SummaryStatsCard
        title='อยู่ระหว่างอนุมัติ'
        displayValue={`${numberOfInReview} รายการ`}
        loading={isLoading}
        color='warning'
      />
      <SummaryStatsCard
        title='ไม่อนุมัติ'
        displayValue={`${numberOfRejected} รายการ`}
        loading={isLoading}
        color='error'
      />
    </Flex>
  );
}
